import React from "react";
import Toolbar from "common_components/toolbar";
import {Description, InfoOutlined} from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import SettingsIcon from "@material-ui/icons/Settings";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import {Button, IconButton, Tooltip} from "@material-ui/core";
import {Link} from "react-router";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import SearchField from "common_components/search_field";
import IconToggle from "common_components/icon_toggle";

interface MatterListToolbarProps {
  organisationId: OrganisationId;
  projectId: ProjectId;
  projectName: string;
  amount: number;
  canUpdateProject: boolean;
  searchText: string;
  onChangeSearchText: (value: string) => void;
  onlyShowMyMatters: boolean;
  onToggleOnlyShowMyMatters: () => void;
}

function Title({name, amount}: {name: string; amount: number}) {
  return (
    <span
      style={{
        marginRight: 10,
        fontSize: "1.25rem",
        fontWeight: 400,
      }}
    >
      {name} - Contract Families {amount ? `(${amount})` : ""}
    </span>
  );
}

function CreateNewButton({organisationId, projectId}) {
  return (
    <Tooltip title="Click here to create a new contract family. You can upload MSAs + SOWs and analyse them together.">
      <Link
        to={`/organisation/${organisationId}/project/${projectId}/matter/new`}
      >
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<AddIcon />}
          endIcon={<InfoOutlined style={{fontSize: "1rem"}} />}
          onClick={() => {}}
        >
          Create New
        </Button>
      </Link>
    </Tooltip>
  );
}

function ProjectSettingsButton({organisationId, projectId, canUpdateProject}) {
  if (!canUpdateProject) {
    return null;
  }
  return (
    <Link to={`/organisation/${organisationId}/project/${projectId}/detail`}>
      <IconButton style={{color: "#91979c"}}>
        <SettingsIcon />
      </IconButton>
    </Link>
  );
}

function MatterListToolbar({
  organisationId,
  projectId,
  projectName,
  amount,
  canUpdateProject,
  searchText,
  onChangeSearchText,
  onlyShowMyMatters,
  onToggleOnlyShowMyMatters,
}: MatterListToolbarProps) {
  return (
    <Toolbar
      icon={<Description />}
      title={<Title name={projectName} amount={amount} />}
      children={
        <>
          <IconToggle
            Icon={AccountCircleIcon}
            tooltip="Only show my contract families"
            enabled={onlyShowMyMatters}
            onToggle={onToggleOnlyShowMyMatters}
          />
          <SearchField
            autoFocus
            searchText={searchText}
            onChangeSearchText={onChangeSearchText}
            title="Search"
          />
          <CreateNewButton
            organisationId={organisationId}
            projectId={projectId}
          />
        </>
      }
      rightChildren={
        <>
          <ProjectSettingsButton
            organisationId={organisationId}
            projectId={projectId}
            canUpdateProject={canUpdateProject}
          />
        </>
      }
      childrenStyles={{marginLeft: "auto"}}
    />
  );
}

export default MatterListToolbar;
